import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { VoucherIssuedForCampaignListByHotelIDAndVoucherID_DetailsPage_Query } from "./query";

type Props = {
	hotelID: string;
	campaignID: string;
};

export const useCampaignDetailsQuery = ({ hotelID, campaignID }: Props) => {
	const { data } = useCustomSuspenseQuery(VoucherIssuedForCampaignListByHotelIDAndVoucherID_DetailsPage_Query, {
		variables: { hotelID, voucherID: campaignID },
	});

	return { data };
};
